import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CompagnieModule } from './compagnie/compagnie.module';
import { AltriSoggettiModule } from './altri-soggetti/altri-soggetti.module';
import { FabbricatiModule } from './fabbricati/fabbricati.module';
import { IspettoratiModule } from './ispettorati/ispettorati.module';
import { PolizzeModule } from './polizze/polizze.module';
import { TipiDannoModule } from './tipi-danno/tipi-danno.module';
import { TipologieCostruttiveModule } from './tipologie-costruttive/tipologie-costruttive.module';
import { ClassiFabbricatoModule } from './classi-fabbricato/classi-fabbricato.module';
import { StatiManutenzioneModule } from './stati-manutenzione/stati-manutenzione.module';

@NgModule({
  imports: [
    CommonModule,
    CompagnieModule,
    PolizzeModule,
    IspettoratiModule,
    FabbricatiModule,
    AltriSoggettiModule,
    TipiDannoModule,
    TipologieCostruttiveModule,
    ClassiFabbricatoModule,
    StatiManutenzioneModule,
  ],
})
export class AnagraficheModule { }
